import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";

export const StyledBadgeActive = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    backgroundColor: "var(--color-vibrant-green)",
    color: "var(--color-vibrant-green)",
    boxShadow: `0 0 0 2px var(--color-true-white)`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

export const StyledBadgeInActive = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    backgroundColor: "var(--secondary-text)",
    color: "var(--secondary-text)",
    boxShadow: `0 0 0 2px var(--color-true-white)`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: "1px solid currentColor",
      content: '""',
    },
  },
}));

export const StyledBadgeNotification = styled(Badge)({
  "& .MuiBadge-badge": {
    color: "var(--color-true-white)",
    backgroundColor: "var(--color-crimson)",
    padding: "0 4px",
    minWidth: "16px",
    height: "16px",
  },
});

export const StyledBadgeNotificationMute = styled(Badge)({
  "& .MuiBadge-badge": {
    color: "var(--color-true-white)",
    backgroundColor: "var(--color-light-gray)",
    padding: "0 4px",
    minWidth: "16px",
    height: "16px",
  },
});
